import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Below you can compare mono, stereo, and binaural recordings of a rotating sound source. Notice how your ability to localize the sound source and the spectral characteristics of the sound change.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [1, 0, 1],
      gap: "2%",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  url: `${config.ASSETS_URL}/02/15/principle/mono.wav`,
                  text: "Mono Recording",
                  icon: "cis-volume-high",
                  theme: "secondary",
                  shape: "round",
                  style: {
                    width: "195px",
                  },
                },
              },
              styles: {
                alignItems: "flex-end",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  url: `${config.ASSETS_URL}/02/15/principle/stereo.wav`,
                  text: "Stereo Recording",
                  icon: "cis-volume-high",
                  theme: "secondary",
                  shape: "round",
                  style: {
                    width: "195px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  url: `${config.ASSETS_URL}/02/15/principle/binaural.wav`,
                  text: "Binaural Recording",
                  icon: "cis-volume-high",
                  theme: "secondary",
                  shape: "round",
                  style: {
                    width: "195px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
